import simpleRestProvider from 'ra-data-simple-rest';
import { fetchUtils, DataProvider } from 'react-admin';

const API_URL = import.meta.env.VITE_API_URL || '/admin/api';

const httpClient = (url: string, options: any = {}) => {
  const token = localStorage.getItem('access_token');
  const headers = new Headers(options.headers || {});

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetchUtils.fetchJson(url, { ...options, headers });
};

const baseProvider = simpleRestProvider(API_URL, httpClient);

export const dataProvider: DataProvider = {
  ...baseProvider,

  getList: async (resource: string, params: any) => {
    // Call the base provider to build URL and make request
    const { json } = await httpClient(
      `${API_URL}/${resource}?${new URLSearchParams({
        filter: JSON.stringify(params.filter || {}),
        range: JSON.stringify([
          params.pagination.page * params.pagination.perPage - params.pagination.perPage,
          params.pagination.page * params.pagination.perPage - 1,
        ]),
        sort: JSON.stringify([params.sort.field, params.sort.order]),
      })}`
    );

    // Extract data and total from response
    return {
      data: json.data || [],
      total: json.total || 0,
    };
  },

  getOne: async (resource: string, params: any) => {
    // Special handling for dashboard stats
    if (resource === 'statistics/dashboard') {
      const { json } = await httpClient(`${API_URL}/statistics/dashboard`);
      return { data: { ...json, id: 'current' } };  // React Admin requires id
    }

    const { json } = await httpClient(`${API_URL}/${resource}/${params.id}`);
    const record = json.data || json;
    return { data: record };
  },

  create: async (resource: string, params: any) => {
    // Handle support/tickets/{id}/messages endpoint
    if (resource.startsWith('support/tickets/') && resource.endsWith('/messages')) {
      const { json } = await httpClient(`${API_URL}/${resource}`, {
        method: 'POST',
        body: JSON.stringify(params.data)
      });
      return { data: json };
    }

    return baseProvider.create(resource, params);
  },
};
